export const DYNAMIC_EXPIRE = 300 // 5 minutes
export const DYNAMIC_PREFETCH_DYNAMIC_STALE = 30 // 30 seconds
